import { CHAIN_ENV_TO_CHAIN } from '@vertex-protocol/client';
import { EQUITY_TOKEN_ICONS } from '../equityTokenIcons';
import { PRIMARY_QUOTE_SYMBOLS } from '../primaryQuoteSymbols';
import { TOKEN_ICONS } from '../tokenIcons';
import { Token } from '../types';

const inkMainnetChainId = CHAIN_ENV_TO_CHAIN['inkMainnet'].id; // 57073
const inkTestnetChainId = CHAIN_ENV_TO_CHAIN['inkTestnet'].id; // 763373

/**
 * Ink Mainnet (chain ID 57073)
 * USDT0 (USD₮0) — Tether's omnichain USDT via LayerZero OFT.
 * Verified on-chain: Nado spotEngine.getToken(0) returns this address.
 * Source: https://docs.usdt0.to/technical-documentation/deployments
 */
export const USDT0_INK: Token = {
  address: '0x0200C29006150606B650577BBE7B6248F58470c1',
  chainId: inkMainnetChainId,
  tokenDecimals: 6,
  symbol: PRIMARY_QUOTE_SYMBOLS.usdt0,
  icon: TOKEN_ICONS.usdt,
};

export const KBTC_INK: Token = {
  address: '0x73e0C0d45E048D25Fc26Fa3159b0aA04bFa4Db98',
  chainId: inkMainnetChainId,
  tokenDecimals: 8,
  symbol: 'kBTC',
  icon: TOKEN_ICONS.btc,
};

/**
 * USDC on Ink Mainnet — Circle's native USDC (FiatTokenProxy).
 * Verified on-chain: Nado spotEngine product ID 5.
 * Bridge: Circle CCTP v2 (not LayerZero OFT).
 */
export const USDC_INK: Token = {
  address: '0x2d270e6886d130d724215a266106e6832161eaed',
  chainId: inkMainnetChainId,
  tokenDecimals: 6,
  symbol: 'USDC',
  icon: TOKEN_ICONS.usdc,
};

export const WETH_INK: Token = {
  address: '0x4200000000000000000000000000000000000006',
  chainId: inkMainnetChainId,
  tokenDecimals: 18,
  symbol: 'wETH',
  icon: TOKEN_ICONS.weth,
};

export const WQQQX_INK: Token = {
  address: '0x4C1AE29c159838fC1b224636E28E086EB69101f7',
  chainId: inkMainnetChainId,
  tokenDecimals: 18,
  symbol: 'wQQQx',
  icon: EQUITY_TOKEN_ICONS.QQQ,
};

export const WSPYX_INK: Token = {
  address: '0xE7E553Cd128F0011777323A0b44a7b96EA1CB540',
  chainId: inkMainnetChainId,
  tokenDecimals: 18,
  symbol: 'wSPYx',
  icon: EQUITY_TOKEN_ICONS.SPY,
};

/**
 * Ink Testnet / Ink Sepolia (chain ID 763373)
 * Test token addresses — zero address used as placeholder.
 */
export const USDT0_INK_TESTNET: Token = {
  // Test USDT0 — placeholder address until the Ink testnet deployment is confirmed.
  address: '0x0000000000000000000000000000000000000000',
  chainId: inkTestnetChainId,
  tokenDecimals: 6,
  symbol: PRIMARY_QUOTE_SYMBOLS.usdt0,
  icon: TOKEN_ICONS.usdt,
};

export const KBTC_INK_TESTNET: Token = {
  address: '0x0000000000000000000000000000000000000000',
  chainId: inkTestnetChainId,
  tokenDecimals: 8,
  symbol: 'kBTC',
  icon: TOKEN_ICONS.btc,
};

export const WETH_INK_TESTNET: Token = {
  address: '0x4200000000000000000000000000000000000006',
  chainId: inkTestnetChainId,
  tokenDecimals: 18,
  symbol: 'wETH',
  icon: TOKEN_ICONS.weth,
};

export const USDC_INK_TESTNET: Token = {
  address: '0x0000000000000000000000000000000000000000',
  chainId: inkTestnetChainId,
  tokenDecimals: 6,
  symbol: 'USDC',
  icon: TOKEN_ICONS.usdc,
};

export const WQQQX_INK_TESTNET: Token = {
  address: '0x0000000000000000000000000000000000000000',
  chainId: inkTestnetChainId,
  tokenDecimals: 18,
  symbol: 'wQQQx',
  icon: EQUITY_TOKEN_ICONS.QQQ,
};

export const WSPYX_INK_TESTNET: Token = {
  address: '0x0000000000000000000000000000000000000000',
  chainId: inkTestnetChainId,
  tokenDecimals: 18,
  symbol: 'wSPYx',
  icon: EQUITY_TOKEN_ICONS.SPY,
};
